module.exports = __webpack_public_path__ + "static/media/imagem_padrao_card_desafio.a4b29cdd.png";